<template>
  <section class="atom-text">

    <el-dialog :key="`dialog-${cid}`" title="Ajouter un lien" :visible.sync="addLinkVisible" :append-to-body="true">
      <el-row>
        <el-col :span="18"><el-input v-if="value.link" type="text" v-model="value.link" placeholder="url"></el-input></el-col>
        <el-col :span="6">
          <el-button v-if="value.link" @click="value.link = null">Supprimer le lien</el-button>
          <el-button v-else @click="$set(value, 'link', 'https://')">Ajouter un lien</el-button>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addLinkVisible = false">Valider</el-button>
      </span>
    </el-dialog>

    <div class="edit" v-if="edit">
      <el-button-group>
        <div class="edit-atom">
          <el-select v-model="value.style.fontSize" size="mini" placeholder="Taille">
            <el-option v-for="fontSize in fontSizes" :key="fontSize.value"
              :label="fontSize.label" :value="fontSize.value" :style="{ fontSize: fontSize.value}"></el-option>
          </el-select>
          <el-color-picker v-model="value.style.color" size="small"></el-color-picker>
          <el-radio-group v-model="value.style.textAlign" size="mini">
            <el-radio-button label="left"><i class="material-icons">format_align_left</i></el-radio-button>
            <el-radio-button label="center"><i class="material-icons">format_align_center</i></el-radio-button>
            <el-radio-button label="right"><i class="material-icons">format_align_right</i></el-radio-button>
          </el-radio-group>
          <div>
            <el-button @click="addLinkVisible = true"><i class="material-icons">link</i></el-button>
            <el-button @click="$emit('meta')"><i class="material-icons">extension</i></el-button>
          </div>
        </div>
      </el-button-group>
    </div>

    <div class="text-container">
      <div v-if="hasPopin" class="popin" :style="popinStyle">
        <el-button @click="command('bold')"><i class="material-icons">format_bold</i></el-button>
        <el-button @click="command('italic')"><i class="material-icons">format_italic</i></el-button>
        <el-button @click="command('underline')"><i class="material-icons">format_underline</i></el-button>
      </div>

      <div v-selection="checkSelection" :id="`contenteditable${cid}`" contenteditable="true" @input="updateValue" v-bind:style="value.style"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AtomText',
  props: ['value', 'cid', 'edit'],
  data() {
    return {
      unique: Math.floor(Math.random() * Math.floor(100000)),
      toEdit: false,
      test: null,
      dialogVisible: false,
      hasLink: false,
      addLinkVisible: false,

      hasPopin: false,
      popinStyle: { top: 0, left: 0 },

      fontSizes: [
        { label: 'Titre', value: '200%' },
        { label: 'Sous-titre', value: '150%' },
        { label: 'Texte', value: '100%' },
        { label: 'Petit texte', value: '70%' },
      ],
      link: '',
    };
  },
  mounted() {
    this.init();
  },
  destroy() {
    document.removeEventListener(this.onSelect());
  },
  methods: {
    init() {
      this.$set(this.value, 'text', this.value.text || 'Texte');
      this.$set(this.value, 'style', this.value.style || {});
      this.$set(this.value, 'meta', this.value.meta || '');
      this.$set(this.value.style, 'textAlign', this.value.style.textAlign || 'center');
      this.$set(this.value.style, 'color', this.value.style.color || '#222222');
      this.$set(this.value.style, 'fontSize', this.value.style.fontSize || '100%');

      this.$el.lastChild.lastChild.innerHTML = this.value.text;
    },
    updateValue(event) {
      this.$emit('input', {
        text: event.target.innerHTML,
        style: this.value.style,
      });
    },
    toggleEdit() {
      this.toEdit = !this.toEdit;
    },
    command(c) {
      document.execCommand(c, false, null);
    },
    checkSelection() {
      const s = document.getSelection();
      let contentEditable = s;
      if (s.baseNode) contentEditable = s.baseNode.parentElement.closest('div[contenteditable]');

      if (contentEditable && s.type === 'Range' && contentEditable.id === `contenteditable${this.cid}`) {
        const x = s.getRangeAt(0).getBoundingClientRect().x - contentEditable.getBoundingClientRect().x;
        const y = s.getRangeAt(0).getBoundingClientRect().y - contentEditable.getBoundingClientRect().y;
        this.hasPopin = true;
        this.popinStyle.top = `${y}px`;
        this.popinStyle.left = `${x}px`;
      } else {
        this.hasPopin = false;
      }
    },
  },
};
</script>

<style lang="sass">
.atom-text
  padding: 2rem 1rem

  div[contenteditable]
    padding: 0
    &:focus
      outline: 0

  .text-container
    position: relative

  .popin
    position: absolute
    margin-top: 0px
    padding: 0.1rem 0 0.05rem
    width: 92px
    background: #ff3c48
    border-radius: 2px
    transform: translateX(-50px) translateY(100%)
    z-index: 1500
    &:after
      content: ""
      position: absolute
      top: -6px
      left: 50%
      margin-left: -7px
      width: 0
      height: 0
      border-style: solid
      border-width: 0 10px 10px 10px
      border-color: transparent transparent #ff3c48 transparent
      transform: rotate(15deg)
    button
      margin: 0
      padding: 0.4rem 0.5rem
      background: transparent
      color: white
      border: none
      border-radius: 0
      & ~ button
        border-left: 1px solid white
      i
        font-size: 0.85rem

</style>
